import React from 'react';
import TerminalHeader from './components/TerminalHeader';
import Hero from './components/Hero';
import Stack from './components/Stack';
import Services from './components/Services';
import Journey from './components/Journey';
import Community from './components/Community';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div className="app">
      <TerminalHeader />
      <Hero />
      <Stack />
      <Services />
      <Journey />
      <div className="bottom-row">
        <Community />
        <Contact />
      </div>
    </div>
  );
}

export default App;
